import axios from 'axios';
import Vue from 'vue';

const state = {
    active: null
};

//This piece handles Google Analytics initialization for the appropriate clients.
//It is taken from the standard Google snippet which is usually included in the index file.
window.dataLayer = window.dataLayer || [];

function gtag(){
    dataLayer.push(arguments);
}

const mutations = {
    activate(state, publisher){
        state.active = publisher;

        if(publisher.data.favicon){
            window.document.querySelector('link[rel="icon"]').href = publisher.data.favicon;
            window.document.title = `${publisher.title} Online`;

            if(publisher.data.ga){
                //Insert the Google Analytics script.
                const ga = document.createElement('script');

                ga.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${publisher.data.ga}`);
                ga.setAttribute('async', true);

                window.document.head.appendChild(ga);

                if(window.location.hostname !== 'localhost'){
                    gtag('js', new Date());
                    gtag('config', publisher.data.ga);
                }
            }

            if(publisher.data.hubspot){
                //Insert the Hubspot script.
                const hs = document.createElement('script');

                hs.setAttribute('src', `https://js.hs-scripts.com/${publisher.data.hubspot}.js`);
                hs.setAttribute('async', true);
                hs.setAttribute('defer', true);

                window.document.head.appendChild(hs);
            }
        }
    }
};

const actions = {
    load({commit, dispatch}){
        return axios.get('/publisher')
        .then(response => commit('activate', response.$data))
        .catch(error => console.log(error));
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
